import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import clazz from 'classnames'; // import Icon, { IconFontProps } from '../MyIcon'
import Spin from '../Spin';
import styled from 'styled-components';
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var StyleLayout = styled.button.withConfig({
    displayName: "Button__StyleLayout",
    componentId: "sc-mr6g9-0"
})([
    "",
    " .spin{margin-right:3px;}&:disabled,&.loading{",
    "}&.loading{pointer-events:none;> span{margin-left:2px;}}> svg{margin-right:6px;}&.primary{",
    " &:hover:not(&:disabled),&:active:not(&:disabled){",
    "}&.loading,&:disabled{",
    "}}&.danger{",
    " &:hover:not(&:disabled),&:active:not(&:disabled){",
    "}&.loading,&:disabled{",
    "}}&.outline{",
    " &.loading,&:disabled{",
    "}}&.dangerLine{",
    " &.loading,&:disabled{",
    "}}&.large{",
    "}&.tiny{",
    "}&.small{",
    "}&.long{width:100%;}&.loading,&[disabled]{cursor:default;}"
], {
    "backgroundColor": "var(--color-btn-bg)",
    "color": "var(--color-text)",
    "paddingLeft": "10px",
    "paddingRight": "10px",
    "textAlign": "center",
    "outline": "2px solid transparent",
    "outlineOffset": "2px",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "height": "28px",
    "borderWidth": "1px",
    "borderColor": "var(--color-border)",
    "borderRadius": "6px",
    "fontSize": "13px"
}, {
    "opacity": "0.5"
}, {
    "color": "var(--color-btn-other)",
    "backgroundColor": "var(--color-text-primary)",
    "borderStyle": "none"
}, {
    "backgroundColor": "var(--color-text-primary-hover)"
}, {
    "opacity": "0.5"
}, {
    "backgroundColor": "var(--color-text-danger)",
    "color": "var(--color-btn-other)",
    "borderStyle": "none"
}, {
    "backgroundColor": "var(--color-text-danger-hover)"
}, {
    "opacity": "0.5"
}, {
    "color": "var(--color-text-primary)",
    "borderColor": "var(--color-text-primary)",
    "backgroundColor": "var(--color-btn-bg)"
}, {
    "opacity": "0.5"
}, {
    "color": "var(--color-text-danger)",
    "backgroundColor": "var(--color-btn-bg)",
    "borderColor": "var(--color-text-danger)"
}, {
    "opacity": "0.5"
}, {
    "height": "40px",
    "fontSize": "15px",
    "paddingLeft": "30px",
    "paddingRight": "30px",
    "minWidth": "50px"
}, {
    "height": "30px",
    "fontSize": "14px",
    "paddingLeft": "20px",
    "paddingRight": "20px"
}, {
    "height": "24px",
    "fontSize": "12px",
    "paddingLeft": "10px",
    "paddingRight": "10px"
});
var Button = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(Button, _PureComponent);
    var _super = _createSuper(Button);
    function Button() {
        _classCallCheck(this, Button);
        var _this;
        _this = _super.apply(this, arguments);
        _this.handleClick = function(e) {
            if (_this.props.loading) {
                return;
            }
            _this.props.onClick && _this.props.onClick(e);
        };
        return _this;
    }
    _createClass(Button, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, disabled = _props.disabled, classnames = _props.classnames, className = _props.className, _type = _props.type, type = _type === void 0 ? 'default' : _type, _size = _props.size, size = _size === void 0 ? 'tiny' : _size, long = _props.long, loading = _props.loading, icon = _props.icon, style = _props.style, _rawType = _props.// iconProps,
                rawType, rawType = _rawType === void 0 ? 'button' : _rawType;
                var _obj;
                var clasname = [
                    (_obj = {}, _defineProperty(_obj, type, !!type), _defineProperty(_obj, "long", long), _defineProperty(_obj, size, !!size), _defineProperty(_obj, "loading", loading != null && loading), _obj),
                    classnames,
                    className
                ];
                return(/*#__PURE__*/ _jsxs(StyleLayout, {
                    type: rawType,
                    style: style,
                    className: clazz([
                        clasname
                    ]),
                    disabled: disabled,
                    onClick: this.handleClick,
                    children: [
                        loading && /*#__PURE__*/ _jsx(Spin, {
                            className: "spin"
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: this.props.children
                        })
                    ]
                }));
            }
        }
    ]);
    return Button;
}(React.PureComponent);
export { Button as default };
